<template>
  <PageTemplate :title="title" :subtitle="subtitle" :loading="loading">
    <v-row class="mt-0 mt-md-2 mt-lg-4">
      <v-col cols="6" md="3" v-for="(item, keyItems) in items" :key="keyItems">
        <ServiceCard :item="item" />
      </v-col>
    </v-row>

    <div v-if="totalItems > items.length" class="mt-8 mt-md-12">
      <ButtonWidget class="justify-center" :to="path"> VER TODOS </ButtonWidget>
    </div>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import { formatToURL } from "../utils/formatToURL";
import ServiceCard from "../components/cards/ServiceCard.vue";
import ButtonWidget from "../components/widgets/ButtonWidget.vue";

const _config = {
  mod: "services",
  path: "/servicos",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    itemsPerPage: 12,
    returnTotalItems: 1,
    totalItems: 0,
    title: "",
    subtitle: "",
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  methods: {
    get() {
      this.$rest(_config.mod)
        .get({
          params: {
            itemsPerPage: this.itemsPerPage,
            returnTotalItems: this.returnTotalItems,
          },
          save: (state, { results, module_informations }) => {
            const list = results.list;
            const totalItems = results.totalItems;
            state.list = list.map(({ id, img, title }) => ({
              img,
              title,
              to: `${this.path}/${formatToURL(title)}-${id}`,
            }));

            this.totalItems = totalItems;
            this.title = module_informations.title;
            this.subtitle = module_informations.subtitle;
          },
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.get();
  },
  watch: {
    $route() {
      this.get();
    },
  },
  components: {
    PageTemplate,
    ServiceCard,
    ButtonWidget,
  },
};
</script>
